import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        list: [],
        total: 0,
    },
    getters: {},
    actions: {
        async fetch({ state }, {
            page, type, filter, query,
        }) {
            const limit = 10;
            const params = {
                offset: (page - 1) * limit,
                limit,
                filter: { type, ...filter },
                search: query,
            };
            const result = await Sdk.Report.PrivateList({ params });
            state.list = result.data.raw;
            state.total = result.data.total;
        },
        preProcessForm(__, data) {
            const url = data.file instanceof File ? URL.createObjectURL(data.file) : data.file;
            return new Sdk.FormData({
                ...data, file: url,
            }, [{
                urls: [url],
                ext: (mimetype) => ({
                    'application/pdf': 'pdf',
                }[mimetype] || 'pdf'),
            }]);
        },
        async create({ dispatch }, data) {
            const form = await dispatch('preProcessForm', data);
            return Sdk.Report.PrivateCreateResource(form);
        },
        async update({ dispatch }, data) {
            const { id, ...payload } = data;
            const form = await dispatch('preProcessForm', payload);
            return Sdk.Report.PrivateUpdateResource(id, form);
        },
        delete(__, data) {
            return Sdk.Report.PrivateDeleteResource(data.id);
        },
    },
};
